import { S_PageStyle } from 'pages/page/PageStyle';
import { OActiveTable } from 'pages/special/OrienteeringPage/OActiveTable';
import { OBottomMap } from 'pages/special/OrienteeringPage/OBottomMap';
import { COORDS, VIEWPORT } from 'pages/special/OrienteeringPage/OConfig';
import { OLeftMap } from 'pages/special/OrienteeringPage/OLeftMap';
import { ORightMap } from 'pages/special/OrienteeringPage/ORightMap';
import { getAreaCorners } from 'pages/special/OrienteeringPage/oUtils2';
import { useState } from 'react';
import { ICoordinates, IViewportExtended } from 'react-give-me-map';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const OrienteeringPage = (props: Props): JSX.Element => {
    const [viewport1, setViewport1] = useState<IViewportExtended>(VIEWPORT);
    const [viewport2, setViewport2] = useState<IViewportExtended>(VIEWPORT);
    const [viewport3, setViewport3] = useState<IViewportExtended>(VIEWPORT);
    const [activeCoordinate, setActiveCoordinate] = useState<number>(0);
    const [corners, setCorners] = useState<{
        topLeft: ICoordinates;
        topRight: ICoordinates;
        bottomRight: ICoordinates;
        bottomLeft: ICoordinates;
    }>(null);
    const [coordinates, setCoordinates] = useState<
        {
            lat: number;
            lng: number;
            xPercent: number;
            yPercent: number;
            hiddenLat?: number;
            hiddenLng?: number;
        }[]
    >(COORDS);

    return (
        <S_OrienteeringPage className={props.className}>
            <S_Top>
                <OActiveTable
                    activeCoordinate={activeCoordinate}
                    onActiveCoordinateChange={setActiveCoordinate}
                    coordinates={coordinates}
                    onCoordinatesChange={setCoordinates}
                    onComputeCorners={() => {
                        const crns = getAreaCorners(/*coordinates*/);
                        setCorners(crns ?? null);
                    }}
                />
                <S_Left>
                    <OLeftMap
                        viewport={viewport1}
                        onViewportChange={setViewport1}
                        onCoordinatesChange={setCoordinates}
                        activeCoordinate={activeCoordinate}
                        coordinates={coordinates}
                    />
                </S_Left>
                <S_Right>
                    <ORightMap
                        viewport={viewport2}
                        onViewportChange={setViewport2}
                        onCoordinatesChange={setCoordinates}
                        activeCoordinate={activeCoordinate}
                        coordinates={coordinates}
                    />
                </S_Right>
            </S_Top>
            <S_Bottom>
                <OBottomMap
                    viewport={viewport3}
                    onViewportChange={setViewport3}
                    corners={corners}
                />
            </S_Bottom>
        </S_OrienteeringPage>
    );
};

const S_OrienteeringPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;

const S_Top = styled.div`
    height: 50%;
    display: flex;
    width: 100%;
    position: relative;
`;

const S_Left = styled.div`
    width: 50%;
    height: 100%;
`;

const S_Right = styled.div`
    width: 50%;
    height: 100%;
`;

const S_Bottom = styled.div`
    height: 50%;
    display: flex;
    width: 100%;
`;
